import { MouseEvent, ReactNode } from "react"
import { URL } from "../interfaces/layouts"
import getDownloadFile from "../utilities/getDownloadFile"

/* Protopia Ecosystem component */
export interface IDownloadBtnProps {
   className?: string, 
   style?: any
   src: URL
   children?: ReactNode | ReactNode[]
   label?: string
}
const DownloadBtn = ( { className, style, src, children, label }: IDownloadBtnProps ): JSX.Element => {
    if(!src) {
        return <></>
    }
    const onClick = (evt:MouseEvent) => { 
        //evt.preventDefault()
        evt.stopPropagation()
        console.log( src )
        getDownloadFile( src )
    }
    return <a 
        className={ `${className ? className : ""} hover pointer ` } 
        style={ style}
        download
        onClick={ onClick }
        href={ src }
        target="_blank" 
        rel="noreferrer"
    > 
        {
            children
                ? 
                children
                :
                <div> {label} </div>
        }
    </a>
}
export default DownloadBtn